module.exports = __webpack_public_path__ + "static/media/best_me_3.06728881.jpg";